<template>
  <div class="productListing" style="width: 100%;padding-bottom:60px;
    position: relative;">
    <!-- <img src="../assets/images/categorybargif.gif" style="width:100%" @click="goToCategoryPage()"> -->
    <img src="../assets/images/catBargif.gif" style="width:100%" @click="goToCategoryPage()">
    <!-- <LifeStyleCategory :categoriesName="categoryTree" /> -->
    <BaseSlider />
    <!-- <brand-list-carousel /> -->
    <ProductCard :dataValue="mallLatestProduct" :title="$t('dailyProduct')" :merchantId="null"
        :pinNumber="null" />
    <ProductCard :dataValue="retailShopProductList" :title="$t('latestCollection')" :merchantId="null"
        :pinNumber="null" />
    <ProductCard :dataValue="mallTopSellingProduct" :title="$t('topSelling')" :merchantId="null"
    :pinNumber="null" />
    
    <div class="all_under_price" v-if="priceCategory.merchandisePriceDTOs && priceCategory.merchandisePriceDTOs.length>0" v-for="item in priceCategory.merchandisePriceDTOs">
      <div class="sub_heading">
        <h4>{{  item.title }}</h4>
      </div>
      <ul>
        <li
          v-for="(product,index) in item.merchandisePriceFilterDTOs"
          :key="index"
          @click="openUnderPriceList(product.merchandiseId)"
        >
          <div v-lazyload class="spinner_wrapper" v-if="product.imageUrl">
            <ImageSpinner class="image_spinner" />
            <img :data-url="product.imageUrl" alt />
          </div>
        </li>
      </ul>
    </div>
  <!-- <div v-for="(showAlternateData,index) in showAlternateDataList" :key="index">
        <div v-if="categoryTree.length" class="alternateList">
          <LifeStyleCategoryCard
            v-if="showAlternateData.evenCategoryIndex <=categoryTree.length-1"
            :categoriesName="categoryTree[showAlternateData.evenCategoryIndex]"
          />
          <div class="all_under_price" v-if="index==0 && priceCategory.merchandisePriceDTOs && priceCategory.merchandisePriceDTOs.length>0">
            <div class="sub_heading">
              <h4>{{  priceCategory.merchandisePriceDTOs[0].title }}</h4>
            </div>
            <ul>
              <li
                v-for="(product,index) in priceCategory.merchandisePriceDTOs[0].merchandisePriceFilterDTOs"
                :key="index"
                @click="openUnderPriceList(product.merchandiseId)"
              >
                <div v-lazyload class="spinner_wrapper" v-if="product.imageUrl">
                  <ImageSpinner class="image_spinner" />
                  <img :data-url="product.imageUrl" alt />
                </div>
              </li>
            </ul>
          </div>
          <div class="all_under_price" v-if="index==2 && priceCategory.merchandisePriceDTOs && priceCategory.merchandisePriceDTOs.length>0">
          <div class="sub_heading">
              <h4>{{  priceCategory.merchandisePriceDTOs[1].title }}</h4>
            </div>
            <ul>
              <li
                v-for="(product,index) in priceCategory.merchandisePriceDTOs[1].merchandisePriceFilterDTOs"
                :key="index"
                @click="openUnderPriceList(product.merchandiseId)"
              >
                <div v-lazyload class="spinner_wrapper" v-if="product.imageUrl">
                  <ImageSpinner class="image_spinner" />
                  <img :data-url="product.imageUrl" alt />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-if="categoryTree.length" class="alternateList">
          <LifeStyleCategoryCard
            v-if="showAlternateData.oddCategoryIndex <=categoryTree.length-1"
            :categoriesName="categoryTree[showAlternateData.oddCategoryIndex]"
          />
        </div>
        <div v-if="bannerSaleResponse.length > 0" class="alternateList">
          <ShopNow
            v-if="showAlternateData.bannerIndex <=bannerSaleResponse.length-1"
            :bannerSale="bannerSaleResponse[showAlternateData.bannerIndex]"
          />
        </div>
      </div> -->
    <div class="home_category" v-if="retailShopProductList && retailShopProductList.length > 0">
      <div class="sub_heading">
        <h4>{{$t('productsSpeciallyForYou')}}</h4>
      </div>
      <ul class="wrap_listing">
        <li
          ref="container"
          class="filter_card"     
          v-for="(product, index) in retailShopProductList"
          :key="index"
          :class="{'displayNone': [0,1,2,3].includes(index),'new-item-card': isTileView === 'LIST_VIEW'}"
        >
        <img src="../assets/images/icons/verified-icon.png" alt="loader" class="mVerified-Icon" v-if="product.sellerLiteDTO.isApproved"/>
       <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable &&isTileView === 'LIST_VIEW'">FREE HOME DELIVERY</p>
          <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage"  @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div class="img_wrapper spinner_wrapper" v-else  @click="goToProductDetail(product.sellerItemRelationshipId)">
              <img src="../assets/images/watermark1.jpg" alt="item" />
            </div>
          <div class="product_detail">
            <p class="product-name">{{ product.productName }}</p>
            <p class="bought rating" style="display:flex;" v-if="parseFloat(product.averageRating) > 0">
            <star-rating
              :read-only="true"
              :increment="0.01"
              :starSize="10"
              active-color="#138808"
              :rating="Number(product.averageRating)"
              :show-rating="false"
            ></star-rating>
            <span style="padding-left: 4px;"> ({{product.ratingNum}})</span>
          </p>
         <p class="bought rating" style="display:flex;" v-else-if="!product.averageRating && $store.state.isViewType === 'GRID_VIEW'">
          No ratings yet
          </p>
            <div class="my_price_section flx">
              <span class="my_price" v-if="product.sellingPrice">
              <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
              <span class="sp-badge" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && $store.state.isViewType === 'LIST_VIEW'">Your Price</span>
              </span>
            <span class="selling_price" v-if="product.sellingPriceWithoutDiscount"
              ><span class="rupee-font">₹​</span>​{{ product.sellingPriceWithoutDiscount }}</span
            >
            <span class="selling_price" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && product.mrp"
              ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
            >
            </div>
            <p class="cod-availability" v-if="product.sellerLiteDTO && product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.codEnable">COD is Available</p>
            <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
            <p class="bought" style="color: black"  @click="viewShop(product.sellerLiteDTO.shopId)">
              {{$t('shop')}} -
              <span style="color: green">{{
                product.sellerLiteDTO.storeName
              }}</span>
            </p>
            <p class="home-delivery-text" v-if="product.sellerLiteDTO.sellerShopSettingDTO && product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable && isTileView === 'GRID_VIEW'">FREE HOME DELIVERY</p>
            <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else>
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
          </div>
        </li>
      </ul>
    </div>
      <NoDataFound v-if="merchandiseProductStatus" class="no_record" />
      <infinite-loading @infinite="getProductsListing" spinner="circles">
        <template slot="no-more" v-if="!merchandiseProductStatus">{{
          $t("noMoreRecord")
        }}</template>
      </infinite-loading>

      <div class="cntntLoad" v-if="loading">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
      <!-- <div class="darkLoader" v-if="loading && !this.retailShopProductList.length">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div> -->
    <show-scratch-card
      v-if="showScratch"
      :scratchArrayValue="scratchArrayValue"
      :scratchSaleId="null"
      :saveScratchAction="scratchArrayValue.id"
      :redeemId="scratchArrayValue.id"
      :appId="200"
      @closeScratch="closeScratchFunc"
    ></show-scratch-card>
  </div>
</template>

<script>
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import BaseSlider from "../components/HomeSection/BaseSlider";
import { mapGetters , mapState } from "vuex";
import types from "../store/types";
import "../assets/css/scratch-card.scss";
// import "../assets/css/home-style.scss";
import LifeStyleCategory from "../components/LifeStyleSection/LifeStyleCategory";
import ListQuantity from "./ListQuantity";
import CopyIcon from "@/components/Icons/CopyIcon";
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import ProductCard from "../components/HomeSection/ProductCard";
import ShopNow from "../components/HomeSection/ShopNow";
import LifeStyleCategoryCard from "../components/LifeStyleSection/LifeStyleCategoryCard";
import ShowScratchCard from "../components/OrderHistorySection/ShowScratchCard";
import BrandListCarousel from './BrandListCarousel.vue';
import StarRating from "vue-star-rating";
export default {
  name: "RetailShopItemList",
  watch: {
    goBack() {
      this.$router.go(-1);
    },
  },
  components: {
    ImageSpinner,
    BaseSlider,
    NoDataFound,
    CopyIcon,
    ListQuantity,
    LifeStyleCategory,
    ProductCard,
    ShopNow,
    LifeStyleCategoryCard,
    BrandListCarousel,
    ShowScratchCard,
    StarRating
  },
  data() {
    return {
    
      showAlternateDataList: [],
      pageIndex: 0,
      type: "TRENDING",
      retailShopProductList: [],
      trendingProductList: [],
      title: "",
      loading: false,
      noRecord: false,
      merchandiseProductStatus: false,
      MerchantId: "",
      isTileView: "",
      showScratch: false,
    };
  },
  computed: {
    ...mapGetters(["priceCategory","couponResponse", "cartSize","categoryTree","mallLatestProduct","mallTopSellingProduct","bannerSaleResponse",]),
  },
  methods: {
    viewShop(sellID) {
     if(sellID && !this.$route.query.shopid){
      this.$store.commit("saveCategories", {
        categories: [],
        catId: 0,
        catIndex: 0
      });
      this.$store.commit(types.CATEGORY_PRODUCT, []);
      // mOST POPULAR
      this.$store.commit("saveData", {
        mostSellingItemList: [],
        mostSellingPageIndex: 0,
        type: "most_selling_item",
      });
      if (sellID != this.$route.query.shopid) {
        if (this.$route.query.source === "ADS_SERVER") {
          if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
          
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      } else {
        if (this.$route.query.source === "ADS_SERVER") {
         if(this.$route.query.campaignUnitIdentifier){
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier +
              '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier
          );
          }else{
            this.$router.push(
            "/daily-needs?shopid=" +
              sellID +
              "&typeOfSource=" +
              this.$route.query.source +
              "&campaignIdentifier=" +
              this.$route.query.campaignIdentifier
          );
          }
        } else {
          this.$router.push("/daily-needs?shopid=" + sellID);
        }
      }
      }
    },
    goToCategoryPage(){
      try {
        JSBridgePlugin.fireEvents("MALL91TAB_SHRENIBAR_CLICK");
      } catch (err) {
        console.log(err);
      }
      this.$router.push('/category-listing?from=LIFESTYLE')
    },
    getUpdatedCartCount() {
      this.$store.commit(
        types.UPDATE_CART_SIZE,
        Math.round(parseInt(this.cartSize) + 1)
      );
    },
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    openUnderPriceList(id) {
      try {
        JSBridgePlugin.fireEvents("UNDER_PRICE_SECTION_BANNER_CLICK");
      } catch (err) {
        console.log(err);
      }
      this.$router.push("/merchandise-product-by-id/" + id + '?type=underPriceBanner');
    },
     getUnderPriceCategory() {
      this.$store
        .dispatch({ type: "getProductType", payload: "PRICE" })
        .then(data => {
          this.$store.commit(types.PRICE_CATEGORY, data.data);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getBannerSale() {
      this.$store
        .dispatch({ type: "getMerchandiseHome", payload: false })
        .then(data => {
          this.$store.commit(
            types.BANNER_SALE_INDEX0,
            data.data.merchandiseBannerDTOs[0]
          );
          this.$store.commit(
            types.BANNER_SALE_INDEX1,
            data.data.merchandiseBannerDTOs[1]
          );
          this.$store.commit(
            types.BANNER_SALE,
            data.data.merchandiseBannerDTOs.splice(2)
          );
          
        })
        .catch(err => {
          console.log(err);
        });
    },
    getLatestCollection() {
      const obj = {
          pageIndex : this.pageIndex,
          shopId:  null, 
          categoryId : null, 
          sortField : 'ITEM_DATE', 
          sortBy : 'DESC', 
          filters : [{
            filterField : 'IS_GMALL_LOCAL_SUPPLY', filterFieldValue : {
              value : true
            }
          },
          {
            filterField : 'INSTOCK', filterFieldValue : {
              value : true
            }
          }]
      }
        ApiCaller(constant.LOCAL_SHOP_URL, "localshop/get-products" , "post", obj , "get")
        .then(data => {
          if (data && data.data.productListingDTOs.length) {
            this.$store.commit(
              types.MALL_LATEST_PRODUCT,
              data.data.productListingDTOs
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
     getTopSellingProduct() {
      const obj = {
          pageIndex : this.pageIndex,
          shopId: null, 
          categoryId : null, 
          sortField : 'PRODUCT_RANK', 
          sortBy : 'DESC', 
          filters : [{
            filterField : 'IS_RETAILSHOP_PRODUCTS', filterFieldValue : {
              value : true
            }
          },
          {
            filterField : 'INSTOCK', filterFieldValue : {
              value : true
            }
          }]
      }
        ApiCaller(constant.LOCAL_SHOP_URL, "localshop/get-products" , "post", obj , "get")
        .then(data => {
          if (data && data.data.productListingDTOs.length) {
            this.$store.commit(
              types.MALL_TOP_SELLING,
              data.data.productListingDTOs
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    goToProductDetail(productSrId) {
      if (this.$route.query.shopid && this.$route.query.source) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=" +
            this.$route.query.source +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else if (this.$route.query.shopid) {
        this.$router.push(
          "/detail/" +
            productSrId +
            "?source=LIFESTYLE" +
            "&shopid=" +
            this.$route.query.shopid
        );
      } else {
        this.$router.push(
          "/detail/" + productSrId + "?source=LIFESTYLE"
        );
      }
    },
    getProductsListing($state) {
      this.loading = true;
      if (this.$store.getters.retailShopPageIndex) {
        this.pageIndex = this.$store.getters.retailShopPageIndex;
      }
      if (this.pageIndex > 0) {
        localStorage.removeItem("LandOnCategoryListingPage");
      }
      const obj = {
          pageIndex : this.pageIndex,
          shopId: null, 
          categoryId : null, 
          sortField : 'ITEM_DATE', 
          sortBy : 'DESC', 
          filters : [{
            filterField : 'IS_RETAILSHOP_PRODUCTS', filterFieldValue : {
              value : true
            }
          },
          {
            filterField : 'INSTOCK', filterFieldValue : {
              value : true
            }
          }]
      }
      ApiCaller(constant.LOCAL_SHOP_URL, "localshop/get-products" , "post", obj , "get")
        .then((data) => {
          this.title = data.data.title;
          this.$store.commit("saveMerchandiseFilterData", {
            prodListTitle: this.title,
          });
          if (data.data.productListingDTOs.length > 0) {
            this.pageIndex += 1;
            this.retailShopProductList.push(...data.data.productListingDTOs);
            this.$store.commit("saveRetailShopData", {
              retailShopList: this.retailShopProductList,
              retailShopPageIndex: this.pageIndex,
            });
            this.loading = false;
            this.merchandiseProductStatus = false;
            $state && $state.loaded();
          } else {
            if (this.retailShopProductList.length === 0) {
              this.merchandiseProductStatus = true;
            }
            this.loading = false;
            $state && $state.complete();
          }
        })
        .catch((err) => {
          this.loading = false;
          $state && $state.complete();
          console.log(err);
        });
    },
    getCategoryTracking(sourceValue) {
      ApiCaller(
        constant.LOCAL_SHOP_URL,
        "add-user-traking/?orderSourceType=" + sourceValue,
        "post"
      )
        .then((data) => {})
        .catch((err) => {
          console.log(err);
        });
    },
    getCategoriesTree() {
      this.loading = true;
      let payloadObject ;
      if(this.$route.query.shopid){
          payloadObject = 'get-category-tree?shopid=' +this.$route.query.shopid
        }else{
          payloadObject = 'get-category-tree'
        }
      ApiCaller(constant.LOCAL_SHOP_URL, payloadObject, 'get')
        .then(data => {
          this.loading = false;
          this.$store.commit(types.CATEGORY_TREE, data.data.childCategories);
          this.createDynamicSlider();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    createDynamicSlider() {
      
      if (this.categoryTree && this.bannerSaleResponse) {
        
        let categoryProduct =
          this.categoryTree.length % 2 == 0
            ? this.categoryTree.length / 2
            : this.categoryTree.length / 2 + 1;
        let bannerSale = this.bannerSaleResponse.length;
        this.showAlternateDataList = [];
        if (categoryProduct > bannerSale) {
          for (let i = 0; i < categoryProduct; i++) {
            this.showAlternateDataList.push({
              bannerIndex: i,
              evenCategoryIndex: i * 2,
              oddCategoryIndex: i * 2 + 1
            });
          }
        } else {
          for (let i = 0; i < bannerSale - 1; i++) {
            this.showAlternateDataList.push({
              bannerIndex: i,
              evenCategoryIndex: i * 2,
              oddCategoryIndex: i * 2 + 1
            });
          }
        }
      }
    },
    closeScratchFunc() {
      this.showScratch = !this.showScratch;
      this.$store.commit('isGlobalScratchScratched' , true)
    },
     getScratchCard() {
      const obj = {
        applicationId: "200"
      };
      this.$store
        .dispatch({type: 'getScratchValue', payload: obj})
        .then(data => {
          if (data) {
            if (
              data &&
              data.data.status == "ACTIVE" &&
              data.data.scratchcardDTO.cardStatus == "INVISIBLE"
            ) {
              this.showScratch = true;
              this.scratchArrayValue = data.data;
            } else if (
              this.scratchArray.status == "ACTIVE" &&
              this.scratchArray.scratchcardDTO.cardStatus == "ACTIVE"
            ) {
              this.showScratch = true;
              this.scratchArrayValue = data.data;
            }
          } else {
            this.$store.commit('isGlobalScratchScratched' , true)
            console.log("already scracthed");
          }
        })
        .catch(err => {
          if (
            err.response.data.message == "AUTHENTICATION_TOKEN_EXPIRED" ||
            err.response.data.message ==
              "AUTHENTICATION_TOKEN_EXPIRED_OR_INVALID"
          ) {
            try {
              _JWT.refereshToken = res => {
                if (res != "fail") {
                  this.$cookie.set("JWT-TOKEN", res);
                  this.getScratchCard();
                } else {
                  this.loading = false;
                }
              };
              JSBridgePlugin.refreshTokens("_JWT.refereshToken");
            } catch (err) {
              this.loading = false;
              console.log(err);
            }
          }
        });

     }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    localStorage.setItem("LandOnBannerListingPage", true);
    
    if(!this.$route.query.tab){
     ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings" , "get")
      .then(data => {
        this.$store.commit('VIEW_TYPE', data.data[0].designStyle);
        this.isTileView = data.data[0].designStyle;
        console.log(this.$route.name)
         if(this.$store.state.isCloudShopHaveNoItem){
           this.$store.commit('CLOUDSHOP_USER',false);
         }
        else if(data.data[0].cloudShopUser && this.$route.path == "/" && this.$route.name == "RetailShopItemList"){
          if(this.$route.path == '/discount-kirana'){
            this.$store.commit('CLOUDSHOP_USER',false);
          }else{
            this.$store.commit('CLOUDSHOP_USER', data.data[0].cloudShopUser);
            this.$router.replace('/one-day-delivery')
          }          
        }else if(data.data[0].cloudShopUser){
          if(this.$route.path == '/discount-kirana'){
            this.$store.commit('CLOUDSHOP_USER',false);
          }else{
            this.$store.commit('CLOUDSHOP_USER', data.data[0].cloudShopUser);
          }
        }else{
          this.$store.commit('CLOUDSHOP_USER',false);
        }
      })
      .catch(err => {
        console.log(err);
      });
    }
    setTimeout(() => { 
        console.log('no query param', this.$route.query.tab, this.$route.query)
      if(this.$route.query.tab === 'openscanner'){
      try {
        _getScanner.openNativeScanner = res => {
          this.loading = false
          if(res.includes('ide')){
              let id = 137;
              let applicationUrl =
                `https://www.mall91.com/#/order-history?tab=localshop&ide=${res.split("ide=")[1]}`;
              let appName = "mall91";
              let iconImageUrl =
                "https://cdn.mall91.com/adeb3918-d492-43ed-86a6-ae4140ce05ec_original.jpg";
              try {
                JSBridgePlugin.openMiniApp(
                  Number(id),
                  applicationUrl,
                  appName,
                  iconImageUrl
                );
              } catch (err) {
                console.log(err);
                window.open("whatsapp://send?text=" + applicationUrl);
              }
            // this.$router.replace(`order-history?tab=localshop&ide=${res.split("ide=")[1]}`)
          }else{
            let id = 137;
              let applicationUrl =
                `https://www.mall91.com/#/order-history?tab=localshop&ide=${res}`;
              let appName = "mall91";
              let iconImageUrl =
                "https://cdn.mall91.com/adeb3918-d492-43ed-86a6-ae4140ce05ec_original.jpg";
              try {
                JSBridgePlugin.openMiniApp(
                  Number(id),
                  applicationUrl,
                  appName,
                  iconImageUrl
                );
              } catch (err) {
                console.log(err);
                window.open("whatsapp://send?text=" + applicationUrl);
              }
            // this.$router.replace(`order-history?tab=localshop&ide=${res}`)
          }
          console.log('jsbridge response', res)
        };
        JSBridgePlugin.openNativeScanner("_getScanner.openNativeScanner");
        console.log('jsbridge response', res)
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
     
    }else{
      console.log('not getting query param', this.$route.query.tab, this.$route.query)
    }
    }, 500)
    // this.getCategoriesTree();
    if (this.bannerSaleResponse.length && this.categoryTree.length) {
      this.createDynamicSlider();
    } else {
      this.getBannerSale();
      this.getCategoriesTree();
    }
    if (!this.priceCategory.merchandisePriceDTOs) {
      this.getUnderPriceCategory();
    }
    if (this.$store.getters.prodListTitle) {
      this.title = this.$store.getters.prodListTitle;
    }
    if (
      this.$store.getters.retailShopList &&
      this.$store.getters.retailShopList.length > 0 &&
      this.$store.getters.retailShopPageIndex
    ) {
      this.retailShopProductList = this.$store.getters.retailShopList;
      this.pageIndex = this.$store.getters.retailShopPageIndex;
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveRetailShopData", {
        retailShopPageIndex: this.pageIndex,
      });
    }
    if (!this.mallLatestProduct.length) {      
        this.getLatestCollection();
      }
    if(!this.mallTopSellingProduct.length){
      this.getTopSellingProduct();
    }
    if (this.retailShopProductList.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
    setTimeout(() => { 
      if(!this.$store.state.isGlobalScratchScratched){
        this.getScratchCard();
      } 
    }, 5000)
  },
};
</script>
<style lang="scss" scoped>
.displayNone{
  display:none
}
.productListing .detail_content .main_customHeading.topZero {
  top: 0;
}
.productListing .detail_content .main_customHeading.topHeight {
  top: 44px;
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
// p.product-name {
//   font-size: 0.87em;
//   font-weight: 500;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   line-height: 1.5;
//   white-space: nowrap;
//   margin-bottom: 5px;
// }
.sortOption {
  color: #0091ff;
}
.noFilter {
  padding-top: 35px;
}
.paddingTop,
.productListing .detail_content.paddingTop {
  padding-top: 0;
}
.productListing .detail_content.paddingMore {
  padding-top: 80px;
}
</style>